<template>
  <div :dir="dir" :class="{ 'font-ar': locale === 'ar', 'font-zh': locale === 'zh-CN' }">
    <AppHeader />
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <AppFooter />
    <ChatWidget />
    <CartDrawer />
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import ChatWidget from './components/chat/ChatWidget.vue'
import CartDrawer from './components/CartDrawer.vue'
import AOS from 'aos'

const { locale } = useI18n()
const dir = computed(() => locale.value === 'ar' ? 'rtl' : 'ltr')

watch(locale, (lang) => {
  document.documentElement.lang = lang
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
  localStorage.setItem('xiongsu-language', lang)
  setTimeout(() => AOS.refresh(), 300)
}, { immediate: true })

AOS.init({ duration: 600, easing: 'ease-out-cubic', once: true, offset: 50 })
</script>

<style>
.fade-enter-active, .fade-leave-active { transition: opacity 0.25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
